<script setup>
import { BaseCard, BaseIcon } from '@edsights/ui-core';
import { computed } from 'vue';
import { replaceBindings } from '@/lib/string-helpers';

const props = defineProps({
    campaign: {
        type: Object,
        required: true
    },
    bindings: {
        type: Object,
        required: true
    }
});

const audience = computed(() => {
    if (!props.campaign.studentFilter.displayAudience) return 'No audience specified';

    if (props.campaign.studentFilter.displayAudience.length > 100) {
        return `${props.campaign.studentFilter.displayAudience.slice(0, 100)}...`;
    }

    return props.campaign.studentFilter.displayAudience;
});

const formatDescription = (description) => {
    return replaceBindings(description, props.bindings);
};

const formatDate = (date) => {
    return new Date(date).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
    });
};
</script>

<template>
    <BaseCard class="past-campaign-card">
        <template #content>
            <div class="past-campaign-card__content">
                <div class="past-campaign-card__header">
                    <BaseIcon icon="clone" />
                    <span>{{ formatDate(campaign.date) }}</span>
                </div>
                <h3 class="past-campaign-card-title">{{ campaign.templateRef.name }}</h3>
                <i>Audience: {{ audience }}</i>
                <p>{{ formatDescription(campaign.touchpointRef.description) }}</p>
            </div>
        </template>
    </BaseCard>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.past-campaign-card {
    display: flex;

    &__content {
        display: flex;
        flex-direction: column;
        gap: 0.75rem;
        margin: 1rem;
    }

    &__header {
        display: flex;
        align-items: center;

        span {
            margin-left: auto;
        }
    }

    :deep(.pi) {
        font-size: 2rem;
        color: $edsights-blue;
    }

    .past-campaign-card-title {
        font-size: 14px;
    }
}
</style>
